import React from 'react';
import PropTypes from 'prop-types';
var Link = function Link(_ref) {
  var url = _ref.url,
    text = _ref.text,
    target = _ref.target,
    className = _ref.className;
  if (!url && !text) {
    return null;
  }
  var shouldOpenNewWindow = target && target === '_blank';
  var handleClick = function handleClick(e) {
    if (shouldOpenNewWindow && typeof window !== 'undefined') {
      window.open(url);
      e.preventDefault();
    }
  };
  return /*#__PURE__*/React.createElement("a", {
    href: url,
    onClick: handleClick,
    className: className
  }, text);
};
export default Link;
Link.propTypes = {
  url: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  target: PropTypes.string,
  className: PropTypes.string
};